import { useRef } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { useUser } from '../../../contexts/User'
import { useData } from '../../../contexts/Data'
import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Tabs from '../../core/Tabs/Tabs'
import Input from '../../forms/Input/Input'
import Checkbox from '../../forms/Checkbox/Checkbox'
import Validators from '../../../forms/Validators'

export const Account = ({}) => {
    const user = useUser()
    const toaster = useToaster()
    const data = useData()

    const changePasswordRef = useRef()
    changePasswordRef.current = () => {
        const formValues = changePasswordForm.$state.value
        koalition.put(`/users/${user.$state._id}/password`, formValues).then((response) => {
            const jwt = response.data.jwt
            koalition.defaults.headers.common.Authorization = `Bearer ${jwt}`
            data.save('jwt', jwt)
            localStorage.setItem('jwt', jwt)
            toaster.success('Password updated successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const passwordMatchValidator = {
        name: 'intervals',
        validate: (value) => value.password === value.passwordConfirmation,
        error: `Password confirmation must match password`
    }

    const changePasswordForm = useFormBuilder({ onSubmit: () => changePasswordRef.current(), controls: {
        password: { validators: [Validators.required] },
        passwordConfirmation: { validators: [Validators.required] },
    }, validators: [passwordMatchValidator] })

    return (
        <div className="container-fluid">
            <form className="card semi-dark" onSubmit={changePasswordForm.$state.onSubmit}>
                <h3>Change Password</h3>

                <main className="row mt-5">
                    <div className="col-md-6 mb-3">
                        <Input type="password" control={changePasswordForm.$state.controls.password} label="New password" />
                    </div>

                    <div className="col-md-6 mb-3">
                        <Input type="password" control={changePasswordForm.$state.controls.passwordConfirmation} label="Confirm the new password" />
                    </div>
                </main>

                <footer className="row justify-content-end mt-4">
                    <div className="col-auto">
                        <button type="submit" className="primary large" disabled={changePasswordForm.$state.invalid}>Update</button>
                    </div>
                </footer>
            </form>
        </div>
    )
}

export default Account